<template>
  <div class="user-withdrawal-management">
    <el-card shadow="never" class="animate__animated animate__fadeInUp">
      <div class="filter-card">
        <div class="filter-bar">
          <div class="filter-group">
            <el-select
              v-model="status"
              placeholder="提现状态"
              clearable
              class="filter-select-sm"
              @change="handleSearch"
            >
              <el-option label="待处理" :value="0" />
              <el-option label="成功" :value="1" />
              <el-option label="失败" :value="2" />
            </el-select>
            <el-select
              v-model="withdrawType"
              placeholder="提现类型"
              clearable
              class="filter-select-sm"
              @change="handleSearch"
            >
              <el-option label="金币提现" :value="1" />
              <el-option label="奖励余额提现" :value="2" />
            </el-select>
            <el-input
              v-model="userId"
              placeholder="搜索用户ID"
              prefix-icon="el-icon-search"
              clearable
              class="filter-input"
              @keyup.enter.native="handleSearch"
            />
            <el-date-picker
              v-model="dateRange"
              type="datetimerange"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              :default-time="['00:00:00', '23:59:59']"
              format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss"
              clearable
              class="filter-daterange"
              @change="handleSearch"
            />
            <date-range-quick v-model="dateRange" @change="handleSearch" />
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="handleSearch"
              >查询</el-button
            >
            <el-button icon="el-icon-refresh" @click="refreshList"
              >重置</el-button
            >
          </div>
          <div class="action-group">
            <el-button
              v-if="canEdit"
              type="success"
              icon="el-icon-download"
              :loading="exportLoading"
              @click="handleExport"
              >导出Excel</el-button
            >
            <el-button
              v-if="canEdit"
              type="primary"
              icon="el-icon-s-finance"
              :disabled="selectedRecords.length === 0"
              @click="handleBatchApprove"
              >批量打款{{
                selectedRecords.length ? `(${selectedRecords.length})` : ""
              }}</el-button
            >
          </div>
        </div>
      </div>

      <div v-if="error" class="error">{{ error }}</div>
      <el-empty
        v-else-if="!loading && records.length === 0"
        description="暂无提现记录"
      />

      <div v-else>
        <el-table
          ref="withdrawalTable"
          :data="records"
          border
          stripe
          v-loading="loading"
          element-loading-text="正在加载提现记录..."
          class="animate__animated animate__fadeIn"
          row-key="id"
          @selection-change="handleSelectionChange"
        >
          <el-table-column
            v-if="canEdit"
            type="selection"
            width="55"
            align="center"
            :selectable="isRowSelectable"
          />
          <el-table-column prop="id" label="ID" width="80" align="center" />
          <el-table-column
            prop="userId"
            label="用户ID"
            width="100"
            align="center"
          />
          <!-- <el-table-column prop="nickname" label="昵称" min-width="120" show-overflow-tooltip /> -->
          <el-table-column prop="type" label="类型" width="120" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.type === 2" type="warning" size="small"
                >奖励余额</el-tag
              >
              <el-tag v-else type="primary" size="small">金币</el-tag>
            </template>
          </el-table-column>
          <!-- <el-table-column prop="riskLevel" label="风险" width="80" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.riskLevel === 1" type="success" size="small">低</el-tag>
              <el-tag v-else-if="scope.row.riskLevel === 2" type="warning" size="small">中</el-tag>
              <el-tag v-else-if="scope.row.riskLevel === 3" type="danger" size="small">高</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column> -->
          <el-table-column
            prop="openid"
            label="手机号"
            min-width="180"
            show-overflow-tooltip
          />
          <el-table-column
            prop="payeeName"
            label="收款人姓名"
            width="120"
            align="center"
            show-overflow-tooltip
          >
            <template slot-scope="scope">
              {{ scope.row.payeeName || "-" }}
            </template>
          </el-table-column>
          <el-table-column label="提现金额" width="120" align="center">
            <template slot-scope="scope">
              <span style="color: #409eff; font-weight: bold"
                >¥{{ formatAmount(scope.row) }}</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="withdrawalTime"
            label="提现时间"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              {{ formatDateTime(scope.row.withdrawalTime) }}
            </template>
          </el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status === 0" type="warning"
                >待处理</el-tag
              >
              <el-tag v-else-if="scope.row.status === 1" type="success"
                >成功</el-tag
              >
              <el-tag v-else-if="scope.row.status === 2" type="danger"
                >失败</el-tag
              >
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="auditTime"
            label="审核时间"
            width="180"
            align="center"
          >
            <template slot-scope="scope">
              {{
                scope.row.auditTime ? formatDateTime(scope.row.auditTime) : "-"
              }}
            </template>
          </el-table-column>
          <el-table-column label="操作" width="220" align="center">
            <template slot-scope="scope">
              <template v-if="canEdit">
                <div
                  v-if="scope.row.status === 0"
                  style="display: flex; gap: 8px; justify-content: center"
                >
                  <el-button
                    type="text"
                    size="small"
                    class="success-text"
                    @click="handleApprove(scope.row)"
                    >通过</el-button
                  >
                  <el-button
                    type="text"
                    size="small"
                    class="danger-text"
                    @click="handleReject(scope.row)"
                    >拒绝</el-button
                  >
                </div>
                <span v-else style="color: #909399; font-size: 12px"
                  >已处理</span
                >
              </template>
              <template v-else>
                <el-tag
                  v-if="scope.row.status === 0"
                  type="warning"
                  size="small"
                  >待处理</el-tag
                >
                <el-tag
                  v-else-if="scope.row.status === 1"
                  type="success"
                  size="small"
                  >成功</el-tag
                >
                <el-tag
                  v-else-if="scope.row.status === 2"
                  type="danger"
                  size="small"
                  >失败</el-tag
                >
              </template>
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-container">
          <el-pagination
            background
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="pagination.page"
            :page-size="pagination.pageSize"
            :page-sizes="[10, 20, 50, 100]"
            :total="pagination.total"
            @current-change="handleCurrentChange"
            @size-change="handleSizeChange"
          />
        </div>
      </div>
    </el-card>

    <el-dialog
      title="审核通过"
      :visible.sync="approveDialogVisible"
      width="400px"
      center
      append-to-body
    >
      <p>
        确定要通过用户
        <strong>{{ currentRecord.nickname || currentRecord.openid }}</strong>
        的提现申请吗？
      </p>
      <p>
        提现金额：<strong style="color: #409eff"
          >¥{{ formatAmount(currentRecord) }}</strong
        >
      </p>
      <p>
        收款人姓名：<strong>{{ currentRecord.payeeName || "-" }}</strong>
      </p>
      <p>
        OpenID：<strong>{{ currentRecord.openid }}</strong>
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="approveDialogVisible = false">取 消</el-button>
        <el-button type="success" @click="confirmApprove">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="批量打款"
      :visible.sync="batchApproveDialogVisible"
      width="480px"
      center
      append-to-body
    >
      <p>
        确定要对选中的
        <strong>{{ selectedRecords.length }}</strong> 条提现申请执行打款吗？
      </p>
      <p>
        合计金额：<strong style="color: #409eff"
          >¥{{ batchTotalAmount }}</strong
        >
      </p>
      <ul class="batch-record-list">
        <li v-for="item in selectedRecords" :key="item.id">
          {{ item.nickname || item.openid }} — ¥{{ formatAmount(item) }}（{{
            item.payeeName || "-"
          }}
          / {{ item.openid }}）
        </li>
      </ul>
      <div slot="footer" class="dialog-footer">
        <el-button
          @click="batchApproveDialogVisible = false"
          :disabled="batchApproveLoading"
          >取消</el-button
        >
        <el-button
          type="success"
          :loading="batchApproveLoading"
          @click="confirmBatchApprove"
          >确定打款</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="审核拒绝"
      :visible.sync="rejectDialogVisible"
      width="420px"
      center
      append-to-body
    >
      <p>
        确定要拒绝用户
        <strong>{{ currentRecord.nickname || currentRecord.openid }}</strong>
        的提现申请吗？
      </p>
      <p>
        提现金额：<strong style="color: #409eff"
          >¥{{ formatAmount(currentRecord) }}</strong
        >
      </p>
      <p>
        收款人姓名：<strong>{{ currentRecord.payeeName || "-" }}</strong>
      </p>
      <p>
        OpenID：<strong>{{ currentRecord.openid }}</strong>
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="rejectDialogVisible = false">取消</el-button>
        <el-button type="danger" @click="confirmReject">确定拒绝</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { get, put } from "@/utils/http";
import * as XLSX from "xlsx";
import FileSaver from "file-saver";
import { getDefaultDateRange } from "@/utils/dateRange";
import { coinsToYuanText } from "@/utils/coinMoney";
import DateRangeQuick from "@/components/DateRangeQuick.vue";

export default {
  name: "UserWithdrawalManagement",
  components: { DateRangeQuick },
  data() {
    return {
      records: [],
      loading: false,
      exportLoading: false,
      error: "",
      status: "",
      withdrawType: "",
      userId: "",
      dateRange: getDefaultDateRange(),
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      approveDialogVisible: false,
      rejectDialogVisible: false,
      batchApproveDialogVisible: false,
      batchApproveLoading: false,
      selectedRecords: [],
      maxBatchSize: 10,
      currentRecord: {},
    };
  },
  computed: {
    canEdit() {
      const role = parseInt(localStorage.getItem("role"), 10);
      return role === 0 || role === 1;
    },
    batchTotalAmount() {
      return this.selectedRecords
        .reduce((sum, r) => sum + Number(this.formatAmount(r) || 0), 0)
        .toFixed(2);
    },
  },
  mounted() {
    this.fetchRecords();
  },
  methods: {
    formatAmount(record) {
      if (!record) return "0.00";
      // 以金币为准：÷10000 保留两位，向下截断不四舍五入
      return coinsToYuanText(record.withdrawalAmount);
    },

    buildQueryParams(includePagination = true) {
      const params = {};
      if (includePagination) {
        params.page = this.pagination.page;
        params.pageSize = this.pagination.pageSize;
      }
      if (this.status !== "" && this.status !== null)
        params.status = this.status;
      if (this.withdrawType !== "" && this.withdrawType !== null)
        params.type = this.withdrawType;
      if (this.userId) params.userId = this.userId;
      const [start, end] = this.dateRange || [];
      if (start) params.startTime = start;
      if (end) params.endTime = end;
      return params;
    },

    applyPageResult(data) {
      const records = data && Array.isArray(data.records) ? data.records : [];
      this.records = records.map((record) => ({
        ...record,
        status: record.status !== undefined ? record.status : 0,
      }));
      this.pagination.total = Number(data && data.total ? data.total : 0);
      this.pagination.pageSize = Number(
        data && data.pageSize ? data.pageSize : this.pagination.pageSize
      );
      this.pagination.page = Number(
        data && data.page ? data.page : this.pagination.page
      );
      this.clearTableSelection();
    },

    async fetchRecords() {
      this.loading = true;
      this.error = "";
      try {
        const response = await get(
          "/admin/userWithdrawalRecords/getUserWithdrawalRecordsList",
          this.buildQueryParams(true)
        );
        this.applyPageResult(response.data);
      } catch (error) {
        this.error = error.message || "获取提现记录失败";
        this.$message.error(this.error);
      } finally {
        this.loading = false;
      }
    },

    handleCurrentChange(page) {
      this.pagination.page = page;
      this.fetchRecords();
    },

    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.pagination.page = 1;
      this.fetchRecords();
    },

    handleSearch() {
      this.pagination.page = 1;
      this.fetchRecords();
    },

    refreshList() {
      this.status = "";
      this.withdrawType = "";
      this.userId = "";
      this.dateRange = getDefaultDateRange();
      this.pagination.page = 1;
      this.fetchRecords();
    },

    async handleExport() {
      this.exportLoading = true;
      try {
        const allRecords = [];
        let page = 1;
        const pageSize = 50;
        let hasMore = true;

        while (hasMore) {
          const params = { ...this.buildQueryParams(false), page, pageSize };
          const response = await get(
            "/admin/userWithdrawalRecords/getUserWithdrawalRecordsList",
            params
          );
          const records = (response.data && response.data.records) || [];

          if (records.length > 0) {
            allRecords.push(...records);
            if (records.length < pageSize) {
              hasMore = false;
            } else {
              page++;
            }
          } else {
            hasMore = false;
          }

          if (
            response.data &&
            response.data.total &&
            allRecords.length >= response.data.total
          ) {
            hasMore = false;
          }
        }

        if (allRecords.length === 0) {
          this.$message.warning("当前条件下没有可导出的数据");
          return;
        }

        const exportData = allRecords.map((record) => {
          let statusText = "-";
          if (record.status === 0) statusText = "待处理";
          else if (record.status === 1) statusText = "成功";
          else if (record.status === 2) statusText = "失败";

          return {
            用户ID: record.userId || record.id,
            昵称: record.nickname || "-",
            提现类型: record.type === 2 ? "奖励余额提现" : "金币提现",
            风险:
              record.riskLevel === 1
                ? "低"
                : record.riskLevel === 2
                ? "中"
                : record.riskLevel === 3
                ? "高"
                : "-",
            OpenID: record.openid || "-",
            收款人姓名: record.payeeName || "-",
            收款人身份证号: record.payeeIdCard || "-",
            "提现金额(元)": this.formatAmount(record),
            提现时间: this.formatDateTime(record.withdrawalTime),
            状态: statusText,
            审核时间: record.auditTime
              ? this.formatDateTime(record.auditTime)
              : "-",
          };
        });

        const wb = XLSX.utils.book_new();
        const ws = XLSX.utils.json_to_sheet(exportData);
        ws["!cols"] = [
          { wch: 10 },
          { wch: 16 },
          { wch: 14 },
          { wch: 8 },
          { wch: 28 },
          { wch: 14 },
          { wch: 20 },
          { wch: 14 },
          { wch: 20 },
          { wch: 10 },
          { wch: 20 },
        ];
        XLSX.utils.book_append_sheet(wb, ws, "提现记录");

        const searchInfo = [];
        const statusMap = { 0: "待处理", 1: "成功", 2: "失败" };
        if (this.status !== "" && this.status !== null)
          searchInfo.push(`状态_${statusMap[this.status] || this.status}`);
        if (this.userId) searchInfo.push(`用户ID_${this.userId}`);
        if (this.dateRange && this.dateRange.length === 2) {
          searchInfo.push(`时间_${this.dateRange[0]}_${this.dateRange[1]}`);
        }
        const fileName = `提现记录_${
          searchInfo.length > 0 ? searchInfo.join("_") : "全部"
        }_${Date.now()}.xlsx`;
        const wbout = XLSX.write(wb, {
          bookType: "xlsx",
          bookSST: true,
          type: "array",
        });
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          fileName
        );
        this.$message.success(`成功导出 ${allRecords.length} 条记录`);
      } catch (error) {
        this.$message.error("导出失败: " + (error.message || "未知错误"));
      } finally {
        this.exportLoading = false;
      }
    },

    isRowSelectable(row) {
      return row.status === 0;
    },

    handleSelectionChange(selection) {
      if (selection.length > this.maxBatchSize) {
        const table = this.$refs.withdrawalTable;
        if (table) {
          selection.slice(this.maxBatchSize).forEach((row) => {
            table.toggleRowSelection(row, false);
          });
        }
        this.$message.warning(`最多只能选择 ${this.maxBatchSize} 条记录`);
        this.selectedRecords = selection.slice(0, this.maxBatchSize);
        return;
      }
      this.selectedRecords = selection;
    },

    clearTableSelection() {
      this.selectedRecords = [];
      const table = this.$refs.withdrawalTable;
      if (table) table.clearSelection();
    },

    handleBatchApprove() {
      if (this.selectedRecords.length === 0) {
        this.$message.warning("请先选择待处理的提现记录");
        return;
      }
      this.batchApproveDialogVisible = true;
    },

    async confirmBatchApprove() {
      const records = [...this.selectedRecords];
      this.batchApproveLoading = true;
      try {
        const results = await Promise.allSettled(
          records.map((record) =>
            put("/admin/userWithdrawalRecords", { id: record.id, status: 1 })
          )
        );
        const successCount = results.filter(
          (r) => r.status === "fulfilled"
        ).length;
        const failCount = results.length - successCount;

        if (failCount === 0) {
          this.$message.success(`批量打款成功，共 ${successCount} 条`);
        } else if (successCount === 0) {
          const firstError = results.find((r) => r.status === "rejected");
          this.$message.error(
            firstError?.reason?.message || "批量打款全部失败"
          );
        } else {
          this.$message.warning(
            `部分成功：成功 ${successCount} 条，失败 ${failCount} 条`
          );
        }

        this.batchApproveDialogVisible = false;
        await this.fetchRecords();
      } catch (error) {
        this.$message.error(error.message || "批量打款失败");
      } finally {
        this.batchApproveLoading = false;
      }
    },

    handleApprove(record) {
      this.currentRecord = record;
      this.approveDialogVisible = true;
    },

    handleReject(record) {
      this.currentRecord = record;
      this.rejectDialogVisible = true;
    },

    async confirmApprove() {
      try {
        await put("/admin/userWithdrawalRecords", {
          id: this.currentRecord.id,
          status: 1,
        });
        this.$message.success("审核通过成功");
        this.approveDialogVisible = false;
        this.fetchRecords();
      } catch (error) {
        this.$message.error(error.message || "审核失败");
      }
    },

    async confirmReject() {
      try {
        await put("/admin/userWithdrawalRecords", {
          id: this.currentRecord.id,
          status: 2,
        });
        this.$message.success("审核拒绝成功");
        this.rejectDialogVisible = false;
        this.fetchRecords();
      } catch (error) {
        this.$message.error(error.message || "审核失败");
      }
    },

    formatDateTime(dateString) {
      if (!dateString) return "-";
      return String(dateString).replace("T", " ");
    },
  },
};
</script>

<style scoped>
.filter-card {
  margin-bottom: 20px;
}
.filter-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  flex-wrap: wrap;
}
.filter-group {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  align-items: center;
  flex: 1;
}
.action-group {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}
.filter-select-sm {
  width: 130px;
}
.filter-input {
  width: 160px;
}
.filter-daterange {
  width: 380px;
}

.error {
  color: #f87171;
  padding: 10px;
  background-color: rgba(239, 68, 68, 0.15);
  border: 1px solid rgba(239, 68, 68, 0.3);
  border-radius: 4px;
  margin-bottom: 20px;
}

.el-table {
  margin-bottom: 20px;
}

.pagination-container {
  display: flex;
  justify-content: flex-end;
}

.success-text {
  color: #67c23a;
}
.danger-text {
  color: #f56c6c;
}

.dialog-footer {
  text-align: right;
}

.batch-record-list {
  margin: 12px 0 0;
  padding-left: 20px;
  max-height: 200px;
  overflow-y: auto;
  font-size: 13px;
  color: #606266;
  line-height: 1.8;
}
</style>
